import React from 'react';

import ViewOrganization from 'screens/organizations/components/ViewOrganization';

const ViewOrganizationScreen = () => <ViewOrganization />;

export default ViewOrganizationScreen;
